export default "__VITE_ASSET__CVZcHAM6__"